import type {Coordinate} from 'ol/coordinate.js';

export function computeRotation(start: Coordinate, end: Coordinate): number {
  const dx = end[0] - start[0];
  const dy = end[1] - start[1];
  const rotation = Math.atan2(dy, dx);
  return rotation;
}
